module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('step', {
    attrs: {
      "navItems": _vm.navItems,
      "index": 1,
      "canNext": true,
      "step": _vm.step
    },
    on: {
      "step": _vm.updateStep,
      "back": function () {
        this$1.$router.push('/group-mgr')
      }
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('form', {
    staticClass: "form-custom pt-0 bg-white"
  }, [_c('h2', [_vm._v(_vm._s(_vm.name ? _vm.$t('class_name') + ':' : _vm.$t('add_a_class')) + _vm._s(_vm.name))])])]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 m-auto"
  }, [_c('ul', {
    staticClass: "list-group list-group-flush mt-5"
  }, _vm._l((_vm.selected), function(item) {
    return _c('li', {
      staticClass: "list-group-item border text-left mb-3 rounded",
      staticStyle: {
        "line-height": "150%"
      }
    }, [_c('div', {
      staticClass: "float-left"
    }, [_c('span', [_vm._v(_vm._s(item.realName))])])])
  }), 0), _vm._v(" "), (_vm.selected.length) ? _c('pagination', {
    staticClass: "mt-3",
    attrs: {
      "current": _vm.selectedData.pageIndex,
      "total": _vm.selectedData.pageCount
    },
    on: {
      "page": _vm.updateSelectedPage
    }
  }) : _vm._e()], 1)])])], 2), _vm._v(" "), _c('step', {
    attrs: {
      "navItems": _vm.navItems,
      "index": 2,
      "step": _vm.step,
      "canNext": _vm.name ? true : false
    },
    on: {
      "step": _vm.updateStep
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control mt-3 col-sm-4 offset-sm-4 my-auto",
    staticStyle: {
      "font-size": "24px",
      "padding": "20px"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('enter_class_name'),
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('switch-button', {
    attrs: {
      "leftLabel": _vm.$t('class_list'),
      "rightLabel": _vm.$t('selected_students')
    },
    on: {
      "status": function (status) {
        this$1.switchOn = status
      }
    }
  })], 1)])]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-8 offset-2"
  }, [_c('ul', {
    staticClass: "list-group list-group-flush"
  }, _vm._l((_vm.students), function(item) {
    return _c('li', {
      staticClass: "list-group-item border text-left mb-3 rounded",
      class: {
        'active': _vm.getSelectedIdx(item.id) > -1
      },
      staticStyle: {
        "line-height": "150%"
      },
      on: {
        "click": function($event) {
          return _vm.edit(item)
        }
      }
    }, [_c('div', {
      staticClass: "float-left"
    }, [_c('span', [_vm._v(_vm._s(item.realName))]), _c('br'), _vm._v(_vm._s(item.userName) + "\n              ")])])
  }), 0), _vm._v(" "), (_vm.switchOn) ? _c('pagination', {
    staticClass: "mt-3",
    attrs: {
      "current": _vm.pageIndex,
      "total": _vm.pageCount
    },
    on: {
      "page": _vm.updatePage
    }
  }) : _vm._e()], 1)])])], 2), _vm._v(" "), _c('step', {
    attrs: {
      "navItems": _vm.navItems,
      "index": 3,
      "step": _vm.step,
      "canNext": _vm.name ? true : false
    },
    on: {
      "step": _vm.updateStep,
      "finish": function () {
        this$1.$router.push('/group-mgr')
      }
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('complete')))])]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "col-8 offset-2"
  }, [_c('ul', {
    staticClass: "list-group list-group-flush"
  }, [_c('li', {
    staticClass: "list-group-item border text-left mb-3 rounded",
    staticStyle: {
      "line-height": "150%"
    }
  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.name)), _c('br'), _vm._v(_vm._s(_vm.$t('established_date')) + "：" + _vm._s('2019-01-01 00:00') + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [_vm._v("\n              " + _vm._s(_vm.$tc('student', _vm.selected.length, {
    count: _vm.selected.length
  })) + "\n            ")])])])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a1ec092!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teacher/TeachingGroupEditor.vue
// module id = 764
// module chunks = 3